import postal from 'postal';
import addOnRequestResponse from './add-ons/request-response';
const eventsBridge = addOnRequestResponse(postal);
export const ebGlobalChannel = eventsBridge.channel('global');
